<ng-container *transloco="let t; read: 'events-calendar'">
  <ng-container [ngSwitch]="eventTypeSelectMode">
    <div class="multiselect-panel--tablet-max">
      <p-multiSelect
        *ngSwitchCase="'multiple'"
        appEventTypeSearch
        [defaultLabel]="t('eventTypeSelectLabel')"
        [formControl]="selectedEventTypes"
        [maxSelectedLabels]="2"
        [selectedItemsLabel]="'{0} ' + t('eventTypesSelected') | lowercase"
        (menuOptionSearchCompleted)="selectedEventTypes.setValue([$event.at(0)?.value])"
      >
      </p-multiSelect>
    </div>
    <div class="dropdown-panel--mobile-only">
      <p-dropdown
        *ngSwitchCase="'single'"
        appEventTypeSearch
        [formControl]="selectedEventTypes"
        [placeholder]="t('eventTypeSelectLabel')"
        (menuOptionSearchCompleted)="selectedEventTypes.setValue($event.at(0)?.value)"
      >
      </p-dropdown>
    </div>
  </ng-container>

  <div class="full-calendar--tablet-max full-calendar--mobile-only" [appLoading]="loading$ | async">
    <full-calendar class="calendar-container" [options]="options$ | async"> </full-calendar>
  </div>
</ng-container>
